import { useContext, useEffect, useRef, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";

import {
  FaCode,
  FaCodepen,
  FaStore,
  FaUserFriends,
  FaUsers,
} from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import Spinner from "../components/layout/Spinner";
import RepoList from "../components/repos/RepoList";
import { getUserAndRepos, getUserStats } from "../context/github/GithubActions";
import { GithubContext } from "../context/github/GithubContext";
import html2canvas from "html2canvas";

const User = () => {
  const { dispatch, user, loading, repos, languages, langStats } =
    useContext(GithubContext);
  const [favouriteLang, setFavouriteLnag] = useState(false);
  const [labelsData, setLabelsData] = useState([]);
  const [labelsStats, setLabelStats] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [barChart, setBarChart] = useState(null);
  //TODO://
  const demo = useRef();

  const dataForBarChart = () => {
    const staredLabel = repos
      .map((repo) => repo.name)
      .sort((a, b) => b["stargazers_count"] - a["stargazers_count"])
      .slice(0, 10);
    const staredData = repos
      .map((repo) => repo.stargazers_count)
      .sort((a, b) => b["stargazers_count"] - a["stargazers_count"])
      .slice(0, 10);
    setBarChart({
      labels: staredLabel,
      datasets: [
        {
          label: "Most stared lanuage ",
          data: staredData,
          backgroundColor: [
            "#ffbb11",
            "#ecf0f1",
            "#50AF95",

            "#2a71d0",
            "#B9345A",
            "#51E1ED",
            "#3DBE29",
            "#8D3DAF",
          ],
        },
      ],
    });
  };

  const params = useParams();
  //TODO:// tESTING
  const downloadAsPng = () => {
    const coverImage = document.querySelector(".demo");
    const downloadImage = html2canvas(coverImage, {
      useCORS: true,
    }).then(function (canvas) {
      const a = document.createElement("a");

      a.href = canvas.toDataURL("image/png"); // convert to dataURL
      a.download = "SALMAN" + ".png";
      a.click();
    });
    console.log(downloadImage);
  };
  // console.log(params);
  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const getUserData = async () => {
      const userData = await getUserAndRepos(params.login);
      dispatch({ type: "GET_USER_AND_REPOS", payload: userData });
    };
    getUserData();
    const getUserStatsFn = async () => {
      const userStatsData = await getUserStats(params.login);

      dispatch({ type: "GET_USER_STATS", payload: userStatsData });
      setFavouriteLnag(true);
    };

    getUserStatsFn();

    // User stats
  }, [dispatch, params.login]);
  useEffect(() => {
    const getUserStatsFn = async () => {
      const userStatsData = await getUserStats(params.login);

      dispatch({ type: "GET_USER_STATS", payload: userStatsData });
    };

    getUserStatsFn();
    setFavouriteLnag(languages.keysSorted);
    setLabelsData(Object.keys(langStats));
    setLabelStats(Object.values(langStats));
    setChartData({
      labels: labelsData,
      datasets: [
        {
          label: "Number Of times you used this lanuage ",
          data: labelsStats,
          backgroundColor: [
            "#ffbb11",
            "#ecf0f1",
            "#50AF95",

            "#2a71d0",
            "#B9345A",
            "#51E1ED",
            "#3DBE29",
            "#8D3DAF",
          ],
        },
      ],
    });
    dataForBarChart();
  }, [params.login, dispatch, favouriteLang]);
  if (loading) {
    return <Spinner />;
  }
  const {
    name,
    type,
    avatar_url,
    location,
    bio,
    blog,
    twitter_username,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    hireable,
  } = user;

  return (
    <>
      <div
        data-theme="retro"
        className=" w-full  bg-neutral mx-auto lg:w-11/12 "
      >
        <div className="mb-4">
          <Link to="/" className="btn btn-ghost">
            Back to search
          </Link>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-8 md:gap-8">
          <div className="custom-card-image mb-6 md:mb-0">
            <div className="rounded-lg shadow-xl card image-full" ref={demo}>
              <figure>
                <img src={avatar_url} />
              </figure>
              <div className="card-body justify-end">
                <h2 className="card-title mb-0">{name}</h2>
                <p>{login}</p>
              </div>
            </div>
          </div>
          <div className="col-span-2">
            <div className="mb-6">
              <h1 className="text-3xl card-title ">
                {name}
                <div className="ml-2 mr-1 badge badge-success">{type}</div>
                {hireable && (
                  <div className="mx-1 badge badge-info ">hireable</div>
                )}
              </h1>
              <h1 className="text-xl px-3 card-title mr-5 rounded-lg shadow-md bg-base-100 stats ">
                <span className="">Favourite Programing language : </span>
                <div className="mx-1  text-2xl  text-secondary ">
                  {languages[0]}
                </div>
              </h1>
              <p>{bio}</p>
              <div className="mt-4">
                <a
                  href={html_url}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline "
                >
                  Visit Github Profile
                </a>
              </div>
              <div className="mt-4">
                <button>
                  <Link className="btn btn-outline " to={"/download"}>
                    GET GITHUB PROFILE CARD
                  </Link>
                </button>
              </div>
            </div>
            <div className="w-full rounded-lg shadow-md bg-base-100 stats">
              {location && (
                <div className="stat">
                  <div className="stat-title text-md">Location</div>
                  <div className="stat-value text-lg">{location}</div>
                </div>
              )}
              {blog && (
                <div className="stat">
                  <div className="stat-title text-md">Website</div>
                  <div className="stat-value text-lg">
                    <a href={`https://${blog}`} target="_blank" rel="noreferer">
                      {blog}
                    </a>
                  </div>
                </div>
              )}
              {twitter_username && (
                <div className="stat">
                  <div className="stat-title text-md">Twitter</div>
                  <div className="stat-value text-lg">
                    <a
                      href={`https://twitter.com/${twitter_username}`}
                      target="_blank"
                      rel="noreferer"
                    >
                      {twitter_username}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-full py-5 mb-6 rounded-lg shadow-md bg-base-100 stats ">
          <div className="stat">
            <div className="stat-figure text-secondary">
              <FaUsers className="text-3xl md:text-5xl" />
            </div>
            <div className="stat-title pr-5">Followers</div>
            <div className="stat-value pr-5 text-3xl md:text:4xl">
              {followers}
            </div>
          </div>
          <div className="stat">
            <div className="stat-figure text-secondary">
              <FaUserFriends className="text-3xl md:text-5xl" />
            </div>
            <div className="stat-title pr-5">Following</div>
            <div className="stat-value pr-5 text-3xl md:text:4xl">
              {following}
            </div>
          </div>
          <div className="stat">
            <div className="stat-figure text-secondary">
              <FaCodepen className="text-3xl md:text-5xl" />
            </div>
            <div className="stat-title pr-5">public repos</div>
            <div className="stat-value pr-5 text-3xl md:text:4xl">
              {public_repos}
            </div>
          </div>
          <div className="stat">
            <div className="stat-figure text-secondary">
              <FaStore className="text-3xl md:text-5xl" />
            </div>
            <div className="stat-title pr-5">public gists</div>
            <div className="stat-value pr-5 text-3xl md:text:4xl">
              {public_gists}
            </div>
          </div>
        </div>

        {chartData && (
          <>
            <h1 className="card-title xl:text-3xl lg:text-xl md:text-lg sm:text-md">
              Top Languages used by {name}
            </h1>
            <div className="flex flex-row  flex-wrap items-center mx-auto lg:w-full	 sm:w-full md:w-full px-4 py-10 bg-cover  bg-base-200">
              <div
                className="basis-1/2 max-h-60 "
                style={{
                  height: "80vh",
                  width: "80vw",
                }}
              >
                <Pie
                  width={"90%"}
                  data={chartData}
                  options={{
                    maintainAspectRatio: false,
                    plugins: {
                      title: {
                        display: true,
                        text: "Top Programming languages used by you",
                      },
                      legend: {
                        display: true,
                        position: "bottom",
                      },
                    },
                  }}
                />
              </div>
              <div className="basis-1/2 ">
                <Bar
                  data={barChart}
                  options={{
                    plugins: {
                      title: {
                        display: true,
                        text: "Most stared lanuage",
                      },
                      legend: {
                        display: true,
                        position: "bottom",
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div className="flex  text-sm text-slate-400	items-baseline		">
              *As of now, your data is Analyzed by your top 100(maximum) latest
              repository{" "}
            </div>
          </>
        )}
        <RepoList repos={repos} />
      </div>
    </>
  );
};
export default User;
